module.exports = __webpack_public_path__ + "images/help/icon-twr54@2xc-2580fd2fc48d22b5eedd36857273c4ef.png";